export class IfcExpressionEvaluationException extends Error {
  constructor(message: string) {
    super(message);
  }
}
